import { QuestionInfo } from "common";

export class AgentInformation {
  constructor(
    public PrimaryAgentStateLicenseNumber: string,
    public PrimaryAgentName: string,
    public PrimaryAgentNumber: string,
    public PrimaryAgentPercentageSplit: string,
    public PrimaryAgentPhone: string,
    public SecondaryAgentStateLicenseNumber: string,
    public SecondaryAgentName: string,
    public SecondaryAgentNumber: string,
    public SecondaryAgentPercentageSplit: string,
    public Questions: QuestionInfo[],
    public Seen: string 
  ) {}
}
